$( document ).ready(function() {
  const items = document.querySelectorAll(".service_faqs_wrapper.accordion button");
  
  function toggleAccordion() {
    const itemToggle = this.getAttribute('aria-expanded');
    
    for (i = 0; i < items.length; i++) {
      items[i].setAttribute('aria-expanded', 'false');
    }
    
    if (itemToggle == 'false') {
      this.setAttribute('aria-expanded', 'true');
    }
  }
  
  items.forEach(item => item.addEventListener('click', toggleAccordion));
  
  $("nav.header__nav.top_menu li a").hover(
    function () {
      $("nav.header__nav.top_menu li a").addClass("result_hover");
      $(this).removeClass("result_hover");
    },
    function () {
      $("nav.header__nav.top_menu li a").removeClass("result_hover");
    }
  );
  $(".header--transparent .header__icon-list a").hover(
    function () {
      $(".header--transparent .header__icon-list a").addClass("result_hover");
      $(this).removeClass("result_hover");
    },
    function () {
      $(".header--transparent .header__icon-list a").removeClass("result_hover");
    }
  );
  $('.category_list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 14,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1441,
      settings: {
        slidesToShow: 10,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    }
  
  ]
});


  
  $(document).on('change', '.product-form__controls-group--submit .flex-container input#agreement', function(){
     if ($(this).is(':checked')) {
       $('.product-form__controls-group--submit .product-form__item--submit button[data-add-to-cart]').removeAttr('disabled');
    } else {
       $('.product-form__controls-group--submit .product-form__item--submit button[data-add-to-cart]').attr('disabled','disabled');
    }
  });
  $(document).on('change', '.product-form__controls-group--submit .made-order-wrapp input#agreement1', function(){
     if ($(this).is(':checked')) {
       $('.product-form__controls-group--submit .product-form__item--submit button[data-add-to-cart]').removeAttr('disabled');
    } else {
       $('.product-form__controls-group--submit .product-form__item--submit button[data-add-to-cart]').attr('disabled','disabled');
    }
  });

  
  



  //Product Page desktop Arrow JS
  if(window.outerWidth > 960 && document.body.classList.contains('template-product')){
    document.querySelectorAll('.cstm-arrow').forEach((arrow_btn) => {
        var max_val = document.querySelectorAll('.product-thumbnails__item').length;
        arrow_btn.addEventListener('click',function(e){
            var curr_slide = document.querySelector('.product-thumbnails__item-link.active').closest('.product-thumbnails__item').getAttribute('data-index');
            if(this.classList.contains('cstm-arrrow-prev')){
                var change_slide = Number(curr_slide);
                if(change_slide != 1){
                    if(document.querySelector('.cstm-arrrow-next').classList.contains('disable-btn')){
                        document.querySelector('.cstm-arrrow-next').classList.remove('disable-btn');	
                    }
                    document.querySelectorAll('.product-thumbnails__item')[change_slide - 2].querySelector('button').click();
                    if(change_slide == 2){
                        if(document.querySelector('.cstm-arrrow-prev').classList.contains('disable-btn') == false){
                            document.querySelector('.cstm-arrrow-prev').classList.add('disable-btn');	
                        }  
                    }
                      
                }
            }else{
                var change_slide = Number(curr_slide);
                if(max_val > change_slide){
                    document.querySelector('.cstm-arrrow-next').classList.remove('disable-btn');
                    if(document.querySelector('.cstm-arrrow-prev').classList.contains('disable-btn')){
                        document.querySelector('.cstm-arrrow-prev').classList.remove('disable-btn');	
                    }
                    document.querySelectorAll('.product-thumbnails__item')[change_slide].querySelector('button').click();
                    if(change_slide == (max_val - 1)){
                        document.querySelector('.cstm-arrrow-next').classList.add('disable-btn');	
                    }    
                }
            }
        })
    })
  }
});